import React from 'react'
import Table from '../Table/Table'
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from 'react-router-dom';
import Paginations from "components/Pagination/Pagination.jsx";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx";

function ContractList({classes}) {
    // mock data
    const sprints = [
        ['1', <Link to="#">ACP-24</Link>, 'As an admin, I want to create many tickets', '4', '1', 'Expires in 3 hours'],
        ['2', <Link to="#">ACP-25</Link>, 'As a Customer, I want to create little tickets', '2', '3', 'Expires in 3 hours'],
    ]
    return (
        <div>
            <Table
                tableHead={[
                    "#",
                    "Contract Id",
                    "Contract Title",
                    "No. of Bidders",
                    "Bid Received",
                    "Bid Expiry"
                ]}
                tableData={sprints}
                customCellClasses={[
                    classes.textCenter,
                    classes.textCenter,
                ]}
                customClassesForCells={[4,5]}
                customHeadCellClasses={[
                    classes.textCenter,
                    classes.textCenter,
                  ]}
                customHeadClassesForCells={[4,5]}
            />
            <Paginations
                pages={[
                { text: "<" },
                { text: 1 },
                { text: 2 },
                { active: true, text: 3 },
                { text: 4 },
                { text: 5 },
                { text: ">" }
                ]}
                color="success"
            />
        </div>
    )
}

export default withStyles(style)(ContractList)
